<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="vx-col w-full mt-base">
          <vs-card class="p2">
            <div slot="header">
              <div class="vx-row m-2">
                <h5>Tambah Hak Akses</h5>
              </div>
            </div>
            <vs-alert color="danger" title="Perhatian !" active="true">
              Pastikan <b>url</b> pada <b>vue router</b> yang ada di Digof-App sudah ditambahkan sebelumnya. Jika router belum ditambahkan
              maka sistem otomatis akan error. Mohon berhati-hati untuk melakukan input data ini.
            </vs-alert>
            <br/>
            <form>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Nama Akses</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="input.name" name="name" v-validate="'required|min:5'"/>
                  <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Tipe Akses (Slug)</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="input.tipe_akses" name="tipe_akses" v-validate="'required|min:5'"/>
                  <span class="text-danger text-sm" v-show="errors.has('tipe_akses')">{{ errors.first('tipe_akses') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>URL</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="input.url" name="url" v-validate="'required|min:5'"/>
                  <span class="text-danger text-sm" v-show="errors.has('url')">{{ errors.first('url') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Icon</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <vs-input class="w-full" type="text" v-model="input.icon" name="icon" v-validate="'required|min:5'"/>
                  <span class="text-danger text-sm" v-show="errors.has('icon')">{{ errors.first('icon') }}</span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Akses Sub Menu Dari</span>
                </div>
                <div class="vx-col sm:w-5/6 w-full">
                  <v-select :options="listParentAkses" v-model="selectedParentAkses" name="parentakses_id"/>
                  <span class="text-danger text-sm" v-show="errors.has('parentakses_id')">{{ errors.first('parentakses_id') }}</span>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col sm:w-5/6 w-full ml-auto">
                  <vs-button 
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-check"
                    class="mb-4 self-end"
                    size="medium"
                    @click="submitAkses()"
                    >Simpan Data
                  </vs-button>
                </div>
              </div>
            </form>
          </vs-card>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4">
        <vs-button
          @click="$router.push({name: 'hak-akses'})"
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="mb-4 self-end"
          size="small"
          > Kembali
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import {CREATE} from '@/query/hak-akses';
import {GET_ALL as ALL_AKSES} from '@/query/hak-akses';

export default {
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      hakAkses: {},
      input: {
        name: '',
        tipe_akses: '',
        url: '',
        icon: '',
        parentakses_id: null,
        show: true,
        is_group: false
      },
      selectedParentAkses: {value : null, label : 'Tanpa Parent Akses'},
      listParentAkses: [{value : null, label : 'Tanpa Parent Akses'}],
    };
  },
  apollo : {
    listParentAkses : {
      query : ALL_AKSES,
      update : (data) => {
        let list = [{value : null, label : 'Tanpa Parent Akses'}];
        data.hakAkses.data.map(item => {
          list.push({ value: item.id, label: item.name });
        });
        return list;
      },
      variables(){
        return {
          perPage: 1000,
          where: {column: "PARENTAKSES_ID", operator: "IS_NULL"}
        }
      },
      fetchPolicy: "cache-and-network",
    },
  },
  watch : {
    selectedParentAkses : {
      deep : true,
      handler(){
        this.input.parentakses_id = this.selectedParentAkses.value;
      }
    },
  },
  methods : {
    async submitAkses(){
      await this.$validator.validateAll().then(result => {
        if(result){
          this.$apollo.mutate({
            mutation : CREATE,
            variables : {
              input : {
                ...this.input,
              }
            }
          })
          .then(() => {
            this.$vs.notify({
              title: 'Berhasil menambah hak akses baru.',
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position : "top-right"
            });
            window.setTimeout(() => {
              this.$router.push({ name: 'hak-akses' });
              // this.$router.push({ name : 'hak-akses-detail', params : {uuid: response.data.uuid} });
            },500);
          })
          .catch((error) => {
            console.error(error);
            if(error.graphQLErrors[0].extensions.validation.length != 0){
              this.$vs.notify({
                title: error.graphQLErrors[0].extensions.validation,
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                position : "top-right"
              });
            }
            else{
              console.error(error);
              this.$vs.notify({
                title: 'Terjadi kesalahan, silahkan hubungi tim IT.',
                color: "danger",
                iconPack: "feather",
                icon: "icon-x",
                position : "top-right"
              });
            }
          });
        }
        else{
          this.$vs.notify({
            title: 'Silahkan lengkapi form terlebih dahulu !',
            color: "danger",
            iconPack: "feather",
            icon: "icon-x",
            position : "top-right"
          });
        }
      });
    },
  }
};
</script>
